import logo from "./logo.svg";
import React, { useState } from "react";
import "./App.css";
import Template from "../src/components/Template";
import { ThemeProvider } from "styled-components";
import { lightTheme, darkTheme } from "./theme";
import { GlobalStyles } from "./global";

function App() {
  const [theme, setTheme] = useState("light");
  const toggleTheme = () => {
    if (theme === "light") {
      setTheme("dark");
    } else {
      setTheme("light");
    }
  };

  return (
    <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
      <div className="App">
        <GlobalStyles />
        <Template onSwitch={toggleTheme} />
      </div>
    </ThemeProvider>
  );
}

export default App;
